// Simple analytics wrapper for development
// Can be enhanced later with full monitoring stack

class SimpleAnalytics {
  constructor() {
    this.initialized = false;
    this.sessionId = this.generateSessionId();
  }

  generateSessionId() {
    return `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;
  }

  track(eventType, properties = {}) {
    if (!this.initialized) return;

    const payload = {
      ...properties,
      session_id: this.sessionId,
      page_path: window.location.pathname,
      timestamp: Date.now()
    };

    // Analytics tracking (silent in production)

    // TODO: Send to analytics services when ready
    // Could be PostHog, Sentry, or custom endpoint
  }

  page(pageName, properties = {}) {
    this.track('page_view', {
      page_name: pageName,
      ...properties
    });
  }

  error(error, context = {}) {
    console.error('[Analytics] Error:', error, context);
    this.track('error', {
      error_message: error.message || String(error),
      ...context
    });
  }
}

// Export singleton instance
const analytics = new SimpleAnalytics();
export default analytics;